import React from 'react';
import {
	DownloadLink,
	ExampleDownload,
	HeaderPlaceholder,
	UploadWrapper,
	Wrapper,
} from './SkuUpload.styles';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import SkuUploadProgress from './SkuUploadProgress/index';
import { UploadSkuStateContext } from 'contexts/UploadSkuStateContext';
import { withRouter } from 'react-router-dom';
import FileList from 'Data/components/FileList';
import { getSKUTemplate } from 'utils/apiRequests';

const SkuUpload = ({
	status,
	refetchSkuState,
	isSkuStateFetching,
	fileArchive,
	fetchFileArchive,
}) => {
	const fileList = fileArchive;
	return (
		<Wrapper>
			<UploadWrapper>
				{isSkuStateFetching ? (
					<ApLoaderDefault />
				) : (
					<>
						<HeaderPlaceholder />
						<SkuUploadProgress
							status={status}
							refetchSkuState={refetchSkuState}
							fetchFileArchive={fetchFileArchive}
						/>
					</>
				)}
			</UploadWrapper>
			<FileList data={fileList.slice(0, 2)} />
			<ExampleDownload>
				<span>
					Please be sure you are uploading an Raw Data in CSV format. You can
					download an example of the expected format below.
				</span>
				<DownloadLink
					href={getSKUTemplate()}
					target="_blank"
					download="template.csv"
				>
					Download example
				</DownloadLink>
			</ExampleDownload>
		</Wrapper>
	);
};

export default withRouter(props => (
	<UploadSkuStateContext.Consumer>
		{({ skuStatus, refetchSkuState, isSkuStateFetching }) => (
			<SkuUpload
				status={skuStatus}
				refetchSkuState={refetchSkuState}
				isSkuStateFetching={isSkuStateFetching}
				{...props}
			/>
		)}
	</UploadSkuStateContext.Consumer>
));
